import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, FormField, Grid, List, Select, Text, TextArea, TextInput } from "grommet";
import { debounce } from "lodash";
import * as React from "react";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import Flag from "../components/Flag";
import StyledModal from "../components/StyledModel";
import ThemeBuilder from "../components/ThemeBuilder";
import OrganizationSearch from "../organizations/OrganizationSearch";
import { Organization } from "../organizations/OrganizationStore";
import { TeamRow } from "../teams/TeamsManagement";
import { getTeams, TeamViewModel } from "../teams/TeamsStore";
import SeedMatchDetails from "./SeedMatchDetails";
import { createSeedMatch, CreateSeedMatchRequest, SeedMatchViewModel } from "./SeedMatchesStore";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const xmark = <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>;

const CreateSeedMatch = () => {
    let [organization, setOrganization] = React.useState({} as Organization);

    let [seedMatch, setSeedMatch] = React.useState(new SeedMatchViewModel());

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    const navigate = useNavigate();

    let create = () => {
        setIsCreating(true);
        createSeedMatch({ ...seedMatch, participantIDs: participants.map((p) => p.id), organizationID: organization.id }).then(
            (result) => {
                navigate(`/seedMatches/${result.seedMatchID}`);
            },
            (error) => {
                setError(error);
            }
        );
    };

    const onChange = (updatedSeedMatch) => {
        setSeedMatch({ ...seedMatch, ...updatedSeedMatch });
    };
    const [teams, setTeams] = React.useState([] as TeamViewModel[]);

    React.useEffect(() => {
        getTeams(organization.id).then((teams) => {
            setTeams(teams);
            setTeamSearchResult(teams);
        });
    }, [organization.id]);

    let [participants, setParticipants] = React.useState([] as TeamViewModel[]);

    let [teamSearchResult, setTeamSearchResult] = React.useState([] as Array<TeamViewModel>);

    const search = (filter) => {
        setTeamSearchResult(
            teams.filter((r) => {
                return r.name.toLowerCase().includes(filter.toLowerCase());
            })
        );
    };

    let [teamFilter, setTeamFilter] = React.useState("");
    const [role, setRole] = React.useState("");

    const [participantCreateError, setParticipantCreateError] = React.useState("");

    React.useEffect(() => {
        search(teamFilter);
    }, [teamFilter]);

    const addParticipant = (team: TeamViewModel) => {
        setParticipantCreateError("");
        if (!participants.find((p) => p.id === team.id)) {
            setParticipants([...participants, team]);
        }
    };

    const [showAddParticipantModal, setShowAddParticipantModal] = React.useState(false);
    const [showRemoveParticipantModal, setShowRemoveParticipantModal] = React.useState(false);
    const [participantToRemove, setParticipantToRemove] = React.useState({} as TeamViewModel);

    const startRemoveParticipant = (participant: TeamViewModel) => {
        setParticipantToRemove(participant);
        setShowRemoveParticipantModal(true);
    };

    const removeParticipant = (participant: TeamViewModel) => {
        setParticipants(participants.filter((p) => p.id !== participant.id));
        setShowRemoveParticipantModal(false);
    };

    return (
        <div>
            <h1>Create SeedMatch</h1>
            <Box>
                <OrganizationSearch onSelect={(organization) => setOrganization(organization)}></OrganizationSearch>
                <SeedMatchDetails seedMatch={seedMatch} isBusy={isCreating} onChange={onChange}></SeedMatchDetails>
                <Box justify="between" gap="small">
                    <Box pad={"small"} gap="small">
                        {participants.length == 0 && <Text>No participants yet</Text>}
                        {participants.map((participant, index) => (
                            <TeamRow team={participant} key={index}>
                                <Button label="Remove" size="small" icon={xmark} onClick={() => startRemoveParticipant(participant)}></Button>
                            </TeamRow>
                        ))}
                    </Box>
                    <Button icon={plus} label="Add Participant" onClick={() => setShowAddParticipantModal(true)}></Button>
                </Box>

                <StyledModal isOpen={showAddParticipantModal} setIsOpen={setShowAddParticipantModal}>
                    <Box width={"medium"}>
                        <FormField label="Search">
                            <TextInput size="xs" value={teamFilter} onChange={(e) => setTeamFilter(e.target.value)} />
                        </FormField>
                        <List
                            pad="xs"
                            data={teamSearchResult}
                            itemKey="id"
                            primaryKey={(team: TeamViewModel) => (
                                <Text size="small" key={team.id}>
                                    <Avatar name={team.name} src={team.logoUri} round size="25px"></Avatar> {team.name}
                                </Text>
                            )}
                            action={(item, index) => <Button hoverIndicator key={item.id} size="small" secondary onClick={() => addParticipant(item)} icon={<FontAwesomeIcon icon={["fad", "caret-right"]}></FontAwesomeIcon>} />}
                        ></List>
                        <Text>
                            <pre>{participantCreateError}</pre>
                        </Text>
                    </Box>
                </StyledModal>

                <StyledModal isOpen={showRemoveParticipantModal} setIsOpen={setShowRemoveParticipantModal}>
                    <Box width={"medium"}>
                        <Text>Are you sure you want to remove this participant?</Text>
                        <Box direction="row" justify="end" pad={"small"} gap="small">
                            <Button onClick={() => setShowRemoveParticipantModal(false)} label="Cancel"></Button>
                            <Button primary onClick={() => removeParticipant(participantToRemove)} label="Remove" color="status-critical"></Button>
                        </Box>
                    </Box>
                </StyledModal>

                <br />
                <Button primary onClick={create} disabled={isCreating || participants.length == 0} label="Create"></Button>
                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default CreateSeedMatch;
